export const environment = {
    production: false,
    lambdaUrls: {
      sendPaymentsData: 'https://p6unsazpe0.execute-api.us-east-1.amazonaws.com/uat/send-payment-data/',
      getOrders: 'https://p6unsazpe0.execute-api.us-east-1.amazonaws.com/uat/get-orders/',
    },
    recaptcha: {
      siteKey: '6LeO3EsrAAAAAGFcZ4IawunVJ32YBmg1AZwdb_fe'
    }
  };
  